/**
 * CampaignDetailsModal - Modal de detalhes de uma campanha disparada
 *
 * Reaproveita 100% o conteúdo da página de detalhes (CampaignDetailsContent),
 * evitando que o usuário perca o contexto (ex.: aba "Campanhas" do modal de
 * cliente/contato) ao consultar os detalhes de um disparo.
 *
 * @version 1.0.0
 * RELEASE: 2026-08-09 v1.0.0 - Criação inicial
 */
import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
import { CampaignDetailsContent } from '@/pages/tenant/CampaignDetails';

interface CampaignDetailsModalProps {
  /** ID da campanha a exibir (null fecha o modal) */
  campaignId: string | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** Modal com os detalhes completos da campanha */
export function CampaignDetailsModal({
  campaignId,
  open,
  onOpenChange,
}: CampaignDetailsModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {/* v1.1.0: largura ampliada para evitar corte dos cards de KPI */}
      <DialogContent
        className="max-w-[1600px] w-[97vw] h-[92dvh] max-h-[92dvh] p-0 gap-0 overflow-hidden sm:rounded-lg"
        aria-describedby={undefined}
      >
        <VisuallyHidden.Root>
          <DialogTitle>Detalhes da campanha</DialogTitle>
        </VisuallyHidden.Root>

        {/* Conteúdo idêntico ao da página, com scroll interno */}
        <div className="h-full overflow-y-auto">
          {campaignId && (
            <CampaignDetailsContent
              campaignId={campaignId}
              variant="modal"
              onClose={() => onOpenChange(false)}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
